import Service from '@ember/service';

export default class LoggingService extends Service {
    logGroup(message, invalid, loggingArgs, inLogging) {
        window.console.groupCollapsed(`%c${message}`, invalid ? 'color: red' : 'color: green');

        inLogging(loggingArgs);

        window.console.groupEnd();
    }

    logNoiseData(plotData, selectedAdc, selectedDriver, adjustedSourceThd) {
        this.logGroup(
            `Calculating Driver Distortion Model for ${selectedDriver.part}`,
            false,
            {
                adcType: selectedAdc.type,
                driverType: selectedDriver.type,
                thdAmp: plotData[1].thd.amp,
                hd2Curve: Math.round(plotData[1].hdCurveData.hd2),
                hd3Curve: Math.round(plotData[1].hdCurveData.hd3),
                hd2SecondInvAmp: Math.round(plotData[1].hdCurveData.secondInvAmp),
                hd3SecondMirrorAmp: Math.round(plotData[1].hdCurveData.mirroredAmpCurve),
            },
            (loggingArgs) => {
                console.log(`ADC type: ${loggingArgs.adcType}`);
                console.log(`Driver type: ${loggingArgs.driverType}`);
                console.log(`Total Driver THD = ${loggingArgs.thdAmp}`);
                console.log(`Hd2 curve = ${loggingArgs.hd2Curve}`);
                console.log(`Hd3 curve = ${loggingArgs.hd3Curve}`);
                console.log(`HD2SecondInvAmp = ${loggingArgs.hd2SecondInvAmp}`);
                console.log(`HD3SecondMirroredAmp = ${loggingArgs.hd3SecondMirrorAmp}`);
            },
        );

        this.logGroup(
            `Calculating ADC Distortion Model for ${selectedAdc.part}`,
            false,
            {
                adcThd: plotData[1].thd.adc,
                adjustedSourceThd: adjustedSourceThd,
                systemThd: plotData[1].thd.system,
            },
            (loggingArgs) => {
                console.log(`ADC THD = ${loggingArgs.adcThd}`);
                console.log(`Source THD set at ${loggingArgs.adjustedSourceThd}`);
                console.log(`System THD = ${loggingArgs.systemThd}`);
            },
        );
    }
}
